import React from 'react';
// For easier mocking
export const useRenderRequest = React.useState;
